import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a78ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Timbratura", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Crea nuova timbratura", -1))
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "content grid grid-cols-2 gap-6" }
const _hoisted_5 = { class: "date text-input col-span-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end-date" }, "Data timbratura", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "user text-input col-span-2"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dipendente", -1))
const _hoisted_10 = {
  key: 0,
  class: "font-light text-red-500"
}
const _hoisted_11 = {
  key: 1,
  class: "working-site text-input grid"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "pb-1" }, "Cantiere", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 2,
  class: "working-site text-input grid"
}
const _hoisted_15 = { class: "pb-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "type text-input grid pb-8 col-span-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "pb-1",
  for: "type"
}, "Tipologia timbratura", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "in" }, "Timbratura in ingresso", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "out" }, "Timbratura in uscita", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalDialog, null, {
      h1: _withCtx(() => [
        _hoisted_1
      ]),
      h2: _withCtx(() => [
        _hoisted_2
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_PrimaryButton, {
            class: "button bg-white text-gray-600 undo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Annulla")
            ]),
            _: 1
          }),
          (_ctx.scope == _ctx.ClockingInScope.user)
            ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                key: 0,
                class: _normalizeClass(["button bg-primary-900 text-white", { disabled : _ctx.selectedWorkingSiteId == undefined }]),
                onClick: _ctx.onCreate
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Crea")
                ]),
                _: 1
              }, 8, ["class", "onClick"]))
            : (_openBlock(), _createBlock(_component_PrimaryButton, {
                key: 1,
                class: _normalizeClass(["button bg-primary-900 text-white", { disabled : _ctx.userId == undefined }]),
                onClick: _ctx.onCreate
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Crea")
                ]),
                _: 1
              }, 8, ["class", "onClick"])),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 2,
                message: "Salvataggio..."
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_DatePicker, {
              mode: "dateTime",
              "input-debounce": 500,
              is24hr: true,
              modelValue: _ctx.time,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.time) = $event))
            }, {
              default: _withCtx(({ inputValue, inputEvents }) => [
                _createElementVNode("input", _mergeProps({
                  class: ["bg-white border-red-400", { border: _ctx.v$.time.$error }],
                  id: "start-date",
                  type: "text",
                  placeholder: "GG/MM/AAAA HH:mm",
                  value: inputValue,
                  onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.time.$touch && _ctx.v$.time.$touch(...args)))
                }, _toHandlers(inputEvents, true)), null, 16, _hoisted_7)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.scope == _ctx.ClockingInScope.workingSite)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_VueMultiselect, {
                  modelValue: _ctx.userId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userId) = $event)),
                  options: _ctx.users.map(u => u.id),
                  "close-on-select": true,
                  "clear-on-select": false,
                  placeholder: "",
                  "custom-label": opt => _ctx.displayNameAndSurname(_ctx.users.find(u => u.id == opt)),
                  "track-by": "surname",
                  onBlur: _ctx.v$.userId.$touch,
                  class: _normalizeClass({ border: _ctx.v$.userId.$error })
                }, null, 8, ["modelValue", "options", "custom-label", "onBlur", "class"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.userId.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "errors",
                    key: error.$uid
                  }, [
                    (error.$validator == 'required')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_10, "È necessario specificare l'utente"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.scope == _ctx.ClockingInScope.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("select", {
                  class: "bg-white",
                  id: "working-site",
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChange($event))),
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedOrderId) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: order.id
                    }, _toDisplayString(order.name), 9, _hoisted_13))
                  }), 256))
                ], 544), [
                  [_vModelSelect, _ctx.selectedOrderId]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.scope == _ctx.ClockingInScope.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, [
                  _createTextVNode("Blocco"),
                  (!_ctx.selectedOrderId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (Seleziona prima un Cantiere)"))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "bg-white",
                  id: "working-site",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedWorkingSiteId) = $event)),
                  disabled: _ctx.selectedOrderId == undefined
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workingSites, (workingSite) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: workingSite.id
                    }, _toDisplayString(workingSite.name), 9, _hoisted_18))
                  }), 256))
                ], 8, _hoisted_17), [
                  [_vModelSelect, _ctx.selectedWorkingSiteId]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["input bg-white", { border: _ctx.v$.clockingInType.$error }]),
              id: "type",
              name: "type",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.clockingInType) = $event)),
              onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.clockingInType.$touch && _ctx.v$.clockingInType.$touch(...args)))
            }, _hoisted_23, 34), [
              [_vModelSelect, _ctx.clockingInType]
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}